import { render, staticRenderFns } from "./AppManYwt.vue?vue&type=template&id=72a561b6&scoped=true"
import script from "./AppManYwt.vue?vue&type=script&lang=js"
export * from "./AppManYwt.vue?vue&type=script&lang=js"
import style0 from "./AppManYwt.vue?vue&type=style&index=0&id=72a561b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a561b6",
  null
  
)

export default component.exports